import * as React from "react";

import LeaderboardAdvertisement from "../leaderboardAdvertisement";
import SquareAdvertisement from "../squareAdvertisement";

const LeaderboardOrSquareAdvertisement = ({ uid, competitionId }) => {
  const [mql, setMql] = React.useState(null);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 54em)");
    setMql(mediaQuery.matches);
  }, []);

  if (mql === null) {
    return null;
  }

  if (mql === true) {
    return <LeaderboardAdvertisement uid={uid} competitionId={competitionId} />;
  }

  return <SquareAdvertisement uid={uid} competitionId={competitionId} />;
};

export default LeaderboardOrSquareAdvertisement;
